import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h4", null, "企业管理员信息", -1)
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "角色设置",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "70%",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", null, [
        _hoisted_1,
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, "企业编号：" + _toDisplayString(_ctx.form.enterpriseCode || '暂无'), 1),
          _createVNode("div", null, "企业名称：" + _toDisplayString(_ctx.form.enterpriseName || '暂无'), 1),
          _createVNode("div", null, "管理员账号：" + _toDisplayString(_ctx.form.accountName || '暂无'), 1)
        ]),
        _createVNode(_component_el_form, {
          model: _ctx.form,
          ref: "formRef",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "选择帐号角色",
              prop: "role"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.role,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.role = $event)),
                  class: "m-2",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.roleName,
                        value: item.roleId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}